import { render, staticRenderFns } from "./BaseActivity.vue?vue&type=template&id=ddf16d56&"
import script from "./BaseActivity.vue?vue&type=script&lang=js&"
export * from "./BaseActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports